import { DEFAULT_PER_PAGE_COUNT } from '@api/services/constants';
import dayjs from '@api/services/tools/dayjs';
import { setAtEndOfDay } from '@api/services/tools/handleUrlParams';
import { getAccountStore } from '@api/store/account/actions';
import { DeliveryLogType, StatusMessageCategory } from '@dev/ee-api/ee-api-models';
import { useSelector } from 'react-redux';

// initial filters for the log tables

interface DefaultLogFiltersInterface {
    to: string;
    from: string;
    statuses: DeliveryLogType[];
    messageCategory?: StatusMessageCategory[];
    email?: string;
    page: number;
    perPage: number;
}

export const useDefaultLogFilters = (inProgressCounts = false): DefaultLogFiltersInterface => {
    const { GeneralInfo } = useSelector(getAccountStore);
    //default is only 3 or 7 days, so if plan can see more than 3 we show 7;
    const limitedDays = GeneralInfo?.KeepLogsForDays;
    const inProgressDate = {
        to: setAtEndOfDay(dayjs().utc().toJSON()),
        from: dayjs().subtract(1, 'day').utc().toJSON(),
    };

    return {
        to: setAtEndOfDay(dayjs().utc().toJSON()),
        from: dayjs()
            .subtract(inProgressCounts ? 2 : limitedDays, 'day')
            .startOf('day')
            .utc()
            .toJSON(),
        ...(inProgressCounts && inProgressDate),
        statuses: [DeliveryLogType.All],
        messageCategory: null,
        email: null,
        page: 1,
        perPage: DEFAULT_PER_PAGE_COUNT,
    };
};
